import React from "react";
import ReactDOM from "react-dom/client";
import Application from "./Application";
import "isomorphic-fetch";
import promise from "es6-promise";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

promise.polyfill();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
);

// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();
